export class JustisUrl {
    constructor(public url: string) {

    }

    public isAnalysisSection() {
        try {
            const urlParts = this.url.split("/");

            return urlParts.length >= 3 && urlParts[2] !== "judgment";
        } catch (error) {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/justis-url.ts